// src/features/learner/components/Navigation/ProgressBar.js
import React from 'react';

export const ProgressBar = ({
    currentIndex,
    totalUnits,
    internalIndex = 0,
    internalTotal = 1,
    completedNavItems = new Set(),
    allContent = []
}) => {
    if (totalUnits === 0) return null;

    // Top bar: percentage of nav items that are fully teal.
    // Falls back to position-based progress if completedNavItems not yet available.
    let mainProgress;
    if (allContent.length > 0) {
        const tealCount = allContent.filter(item => completedNavItems.has(item.id)).length;
        mainProgress = (tealCount / allContent.length) * 100;
    } else {
        mainProgress = ((currentIndex + 1) / totalUnits) * 100;
    }

    const showInternalProgress = internalTotal > 1;

    return (
        <div style={{ padding: '6px 0 2px', display: 'flex', flexDirection: 'column', gap: '3px' }}>

            {/* Main progress: furthest position reached in lesson */}
            <div style={{
                height: '5px',
                backgroundColor: '#e5e7eb',
                borderRadius: '3px',
                overflow: 'hidden'
            }}>
                <div style={{
                    height: '100%',
                    width: `${mainProgress}%`,
                    backgroundColor: '#19a4a0',
                    borderRadius: '3px',
                    transition: 'width 0.3s ease'
                }} />
            </div>

            {/* Internal progress: position within a multi-page unit */}
            {showInternalProgress && (
                <div style={{
                    height: '3px',
                    backgroundColor: '#e5e7eb',
                    borderRadius: '2px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        height: '100%',
                        width: `${((internalIndex + 1) / internalTotal) * 100}%`,
                        backgroundColor: '#19a4a0',
                        opacity: 0.5,
                        borderRadius: '2px',
                        transition: 'width 0.3s ease'
                    }} />
                </div>
            )}

        </div>
    );
};